import styled, { keyframes } from 'styled-components';
import { Col } from 'antd';
import { DEFAULT_RISK_RPN_COLOR } from '@/utils/constants';

const rotate = keyframes`
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(360deg);
	}
`;

const bounceInUp = keyframes`
	0% {
		opacity: 0;
		transform: translateY(100%);
	}
	60% {
		opacity: 1;
		transform: translateY(-8%);
	}
	80% {
		transform: translateY(5%);
	}
	100% {
		transform: translateY(0);
	}
`;

const fadeIn = keyframes`
	0% {
		opacity: 0;
	}
	100% {
		opacity: 1;
	}
`;

export const SpinnerContainer = styled(Col)`
	display: flex;
	position: relative;
	align-items: center;
	justify-content: center;
	margin-bottom: 20px;
	svg {
		color: ${DEFAULT_RISK_RPN_COLOR};
		font-size: 3.5rem;
	}
	.loading-icon {
		position: absolute;
		z-index: 10;
	}
	svg.bounce-in-up {
		animation: ${bounceInUp} 0.8s cubic-bezier(0.4, -0.03, 0.63, 1.28) forwards;
	}
	.fade-in {
		opacity: 0;
		animation: ${fadeIn} 0.5s ease-out 1.3s forwards;
	}
`;

export const Spinner = styled.div`
	width: 150px;
	height: 150px;
	display: flex;
	position: relative;
	border-radius: 50%;
	align-items: center;
	justify-content: center;
	animation: ${rotate} 2s linear infinite;
	background: conic-gradient(
		from 180deg at 50% 50%,
		rgba(255, 255, 255, 0.5) 0deg,
		${DEFAULT_RISK_RPN_COLOR} 296.17deg,
		${DEFAULT_RISK_RPN_COLOR} 359.96deg,
		${DEFAULT_RISK_RPN_COLOR} 360deg
	);
	&::before {
		content: '';
		width: 70%;
		height: 70%;
		border-radius: 50%;
		position: absolute;
		background-color: white;
	}
`;

export const EditButton = styled.button`
	width: 100%;
	padding: 6px;
	font-size: 1rem;
	border-radius: 6px;
	background-color: #ffffff;
	border: 1px solid #d9d9d9;
	box-shadow: 0px 2px 0px 0px #0000000b;
	&:hover {
		cursor: pointer;
	}
`;

export const DeleteButton = styled.button`
	width: 100%;
	padding: 6px;
	color: white !important;
	font-size: 1rem;
	border-radius: 6px;
	border: 1px solid #d9d9d9;
	background-color: rgb(231, 65, 80);
	box-shadow: 0px 2px 0px 0px #0000000b;
	&:hover {
		cursor: pointer;
	}
`;
